import { Link } from "react-router-dom";
import AdminHeader from './AdminHeader';


function AdminHome() {
  
  return (
     <>
      <AdminHeader/>
      
      <Link 
        to="sites" 
        className='form-button primary'
      >Sites
      </Link> 
    </>
  );

}


export default AdminHome;
